import React from 'react';

const IconDT = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4774_387909)">
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
          fill="#FABB39"
        />
        <path
          d="M13.5998 6.77628C13.6381 6.49042 13.5236 6.20652 13.3166 6.07391C13.1095 5.9413 12.8573 5.99035 12.6926 6.19528L8.40692 11.5286C8.27958 11.6871 8.22474 11.9145 8.26095 12.134C8.29716 12.3536 8.41957 12.5358 8.58676 12.619L10.865 13.753L10.4002 17.2237C10.3619 17.5096 10.4764 17.7935 10.6834 17.9261C10.8905 18.0587 11.1427 18.0096 11.3074 17.8047L15.5931 12.4714C15.7204 12.3129 15.7753 12.0855 15.7391 11.866C15.7028 11.6464 15.5804 11.4642 15.4132 11.381L13.135 10.247L13.5998 6.77628Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4774_387909">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconDT;
